import { MemoIconEnum } from '../../../generated/api.graphql';
import type { MemoAttributes as GQLInput } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** A memo create or update; `id` absent creates. */
export type MemoInput = {
  id?: number;
  title?: string;
  description?: string | null;
  startDate?: string;
  endDate?: string;
  icon?: MemoIconEnum | null;
};

const GQL_FIELDS = ['description', 'endDate', 'icon', 'id', 'startDate', 'title'] as const;

// `MemoAttributes.icon` is a bare string validated against the model's values, not the enum names reads return.
const WIRE_ICONS: Record<MemoIconEnum, string> = {
  [MemoIconEnum.Delivery]: 'delivery',
  [MemoIconEnum.Holiday]: 'holiday',
  [MemoIconEnum.Maintenance]: 'maintenance',
  [MemoIconEnum.Note]: 'note',
  [MemoIconEnum.OutOfOffice]: 'out_of_office',
};

const toWireIcon = (icon: MemoIconEnum | null | undefined): GQLInput['icon'] | undefined => {
  if (icon === undefined || icon === null) {
    return icon;
  }

  return WIRE_ICONS[icon];
};

export const toGqlInput = (input: MemoInput): GQLInput =>
  take<GQLInput, MemoInput>({ ...input, icon: toWireIcon(input.icon) }, ...GQL_FIELDS);
